// Repairs cart lines that arrived without a spring force, and keeps the checkout closed until
// every one of them is answered.
//
// Shopify's "Buy again" button re-adds the variant through its own endpoint, which sends no
// line item properties: the reordered spring reaches the cart with no pressure attached. The
// select rendered by `cart-force-select.liquid` writes the property onto the existing line
// through the cart change API, reusing CartItems.updateQuantity so the loading state, the
// error handling and the section re-render are the theme's own.
class CartForceSelect extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    if (!this.select) return;

    this.select.addEventListener('change', this.onChange.bind(this));
  }

  onChange() {
    if (this.select.value === '') return;

    const cartItems = this.closest('cart-items, cart-drawer-items');
    if (!cartItems) return;

    // A change request overwrites the whole properties object, so the ones the line already
    // carries are merged back in rather than dropped.
    const stored = this.querySelector('[data-line-properties]');
    const properties = Object.assign({}, stored ? JSON.parse(stored.textContent) : {}, {
      [this.dataset.propertyName]: this.select.value,
    });

    cartItems.updateQuantity(this.dataset.line, this.dataset.quantity, null, this.dataset.variantId, properties);
  }
}

customElements.define('cart-force-select', CartForceSelect);

// The checkout button and its note sit outside the part of the footer the cart re-renders, so
// Liquid sets their blocked state on load and this keeps them in step afterwards. A line still
// holding a `cart-force-select` is a line with no force chosen.
function syncForceGuard() {
  const pending = document.querySelector('cart-force-select') !== null;
  const footer = document.getElementById('main-cart-footer');
  const empty = footer !== null && footer.classList.contains('is-empty');

  // The weight limit blocks the same two controls and marks what it blocked, so
  // this sync has to OR its state in. Assigning outright would lift the block on
  // every cart update. See `th-weight-limit.js`.
  const overWeight = document.querySelector('[data-th-weight-blocked="true"]') !== null;

  document.querySelectorAll('[data-force-guard]').forEach((element) => {
    switch (element.dataset.forceGuard) {
      case 'checkout':
        // An empty cart disables the button for its own reasons; the guard must not lift that.
        element.disabled = pending || empty || element.dataset.thWeightBlocked === 'true';
        break;
      case 'buttons':
        // The accelerated buttons bypass the cart form, so they go away entirely.
        element.hidden = pending || overWeight;
        break;
      default:
        element.hidden = !pending;
    }
  });
}

document.addEventListener('DOMContentLoaded', syncForceGuard);

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, syncForceGuard);
}
